const inputs = [
  '16.22',
  '1.2f',
  '12f',
  3.4,
  5.5,
  5456,
  'a223',
  '000.00131544',
  'f2',
  '136',
  '',
];

export const parseNumber = (value, defaultValue = Number.MIN_VALUE, format, min, max) => {
  return Number(value) || defaultValue;
  // return parseInt(value);
}

/** Returns a Integer Array that returns the Numbers between and including the Starting Number and the End Number */
export const getIntegerRange = (start = 0, end = 0, step = 1) => {
  if (start > end) {
    return [];
  }

  let retArray = [], cur = start;

  while (cur <= end) {
    retArray.push(cur);
    cur += step;
  }

  return retArray;
}

// console.log(getIntegerRange(10, 25));


// console.log(inputs.map(i => `${i} => ${parseNumber(i)}`).join('\n'));
// console.log(getIntegerRange(0))


export const pixelifyNumber = (value, defaultValue = 'auto') => {
  if (value) {
    if (typeof value === 'string') {
      return value;
    } else if (typeof value === 'number') {
      return value + 'px';
    }
  } else {
    return defaultValue;
  }
}

/** Calculate the percentage of the first argument. This is a curried function */
export const calcPercent = (percent) => value => {
  percent = +percent;
  value = +value;

  if (!isNaN(percent) && !isNaN(value)) {
    return (percent * value) / 100;
  } else {
    return 0;
  }
}


// Work in Progress, 
// IS NOT WORKING AS EXPECTED
// Example: 4657894567 does not work
// For now numbers really small works
// Mainly to use FixedFormatter 
// So many more Combinations to Test
export const CustomNumberFormatter = (() => {
  function formatNumber(num, totalDigits) {
    const [whole, fraction = ''] = num.toString().split('.');
    if (whole.length + fraction.length > totalDigits) {
      return num.toFixed(totalDigits - whole.length);
    }
    return num.toFixed(totalDigits - whole.length);
  }

  const formatDefault = (locale, num) => {
    return new Intl.NumberFormat(locale, {
    }).format(num)
  }

  function isExponential(num) {
    const str = num.toString();
    return str.includes('e');
  }

  function getExponent(num) {
    const str = num.toString();
    const parts = str.split('e');
    return parts.length > 1 ? Number.parseInt(parts[1], 10) : null;
  }

  const fixedFormatter = (fixedLength, locale, num) => {

    const numLength = num.toString().length;

    if (isExponential(num)) {
      const exponent = getExponent(num);
      return num.toExponential(fixedLength - 4 - (Math.abs(exponent).toString()?.length));
    }
    
    const [whole, fraction = ''] = num.toString().split('.');
    const fractionDigit = whole.length < fixedLength 
    ? fixedLength - whole.length - 1  // 1 For the Decimal
    : 0 ; 

    if (whole.length > fixedLength ) {
      return num.toExponential(fixedLength - 6)
    }

    if (whole.length + 1 === fixedLength ) {
      if (!fraction) {
        return `${whole}.`;
      } 
      return num.toExponential(fixedLength - 6)
    }
    
    const adjustedNumber = num.toFixed(fractionDigit);

    const defFormattedNumber = formatDefault(locale, adjustedNumber);

    if (defFormattedNumber.length < fixedLength && !defFormattedNumber.includes('.')) {
      const fmtFraction = fixedLength - defFormattedNumber.length-1;

      return new Intl.NumberFormat(locale, {
        maximumFractionDigits: fmtFraction,
        minimumFractionDigits: fmtFraction,
      }).format(adjustedNumber);
    }

    return adjustedNumber;



    // const formattedNum = formatNumber(num, 15);
  };

  return {
    fixedFormatter,
  }
})();


console.log([  
  1,
  123456789,
  12345678910,
  123456789101,
  1234567891011,
  12345678910111,
  12345678910111.2,
  123456789101112,
  1234567891011121,
  9.168521716226252e+44,
  123456789.1,
  123456789.12,
  123456789.123,
  123456789.1234,
  123456789.12345,
  123456789.123456,
  0.01,
  0.002,
  0.0003,
  0.00004,
  0.000005,
  0.0000006,
  0.00000007,
  0.000000008,
  0.0000000009,
  0.00000000010,
  0.000000000011,
  0.1,
  0.12,
  0.123,
  0.1234,
  0.12345,
  0.123456,
  0.1234567,
  0.12345678,
  0.123456789,
  0.1234567891,
  0.12345678912,
  0.123456789123,
  0.1234567891234,
  0.1,
  1.12,
  12.123,
  123.1234,
  1234.12345,
  12345.123456,
  123456.1234567,
  1234567.12345678,
  12345678.123456789,
  12345689.123456789,

].map(e => {
  return [
    CustomNumberFormatter.fixedFormatter(17, 'en', e), CustomNumberFormatter.fixedFormatter(17, 'en', e)?.length
  ]
}));